/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Search = {
  searchRequests: Array<string>;
};

/** @internal */
export const Search$inboundSchema: z.ZodType<Search, z.ZodTypeDef, unknown> = z
  .object({
    search_requests: z.array(z.string()),
  }).transform((v) => {
    return remap$(v, {
      "search_requests": "searchRequests",
    });
  });
/** @internal */
export type Search$Outbound = {
  search_requests: Array<string>;
};

/** @internal */
export const Search$outboundSchema: z.ZodType<
  Search$Outbound,
  z.ZodTypeDef,
  Search
> = z.object({
  searchRequests: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    searchRequests: "search_requests",
  });
});

export function searchToJSON(search: Search): string {
  return JSON.stringify(Search$outboundSchema.parse(search));
}
export function searchFromJSON(
  jsonString: string,
): SafeParseResult<Search, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Search$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Search' from JSON`,
  );
}
